import React from 'react';

import { EditorContent } from '@tiptap/react';
import { useRichTextEditor } from '@producer/ui-kit';

import { CollapsibleItem } from '../../../components/collapsible-item/collapsible-item';

import type { Step } from '../../../app/entities';
import { EditorBubbleMenu } from '../../../components/rich-editor/editor-bubble-menu';

import styles from './production-notes.module.scss';
type ProductionNotesProps = {
  step: Step;
};

export const ProductionNotes: React.FC<ProductionNotesProps> = ({ step }) => {
  const { editor, isTextSelected } = useRichTextEditor({
    key: step._id,
    value: step.productionNotes || '',
    onBlur: (text) => {
      step.update({ productionNotes: text });
    },
  });

  return (
    <CollapsibleItem title="Shooting Day Notes" defaultOpen>
      {editor && isTextSelected && <EditorBubbleMenu editor={editor} />}
      {editor && <EditorContent className={styles['notes-input']} editor={editor} />}
    </CollapsibleItem>
  );
};
